import useReveal from '../components/useReveal';
import { CgFileDocument } from "react-icons/cg";

function Reveal({ children, delay = 0, className = '' }) {
  const ref = useReveal();
  return <div ref={ref} className={`reveal ${className}`} style={{ transitionDelay: `${delay}ms` }}>{children}</div>;
}

const timeline = [
  { year: '2026', title: 'First Institutional Exhibition', body: 'First work to be shown in an institutional context. A kinetic work that responds to the movements of visitors in an exhibition. Visualizing movement pattenrs as a interractive installation.' },
  { year: '2025', title: 'Started a Masters Degree', body: 'Pursuing my masters drgree in Connected Environments at UCL, London. Became quite interested in the intersection of technology and art where electronics meets creative outputs and experiences.' },
  { year: '2023', title: 'Software Development Role', body: 'Worked for almost 2 years in this sector. Scalling up applications, developing interconnected systems and building user interfaces. Gained an interest in how electronics works and how to program them.' },
  { year: '2019', title: 'Started Bachelors Degree in Computer Science', body: 'Started in software and learnt building data infrastructure and software applications — the technical foundation that now underpins the installation work.' },
];

export default function About() {
  return (
    <div className="pt-16">

      {/* Header */}
      <div className="border-b border-cream-400/60 min-h-[55vh] flex items-center justify-center px-10 md:px-16 lg:px-20 py-20  bg-gradient-to-b from-[#FFFBEA] via-[#F8F3D6] to-[#FFFDF5]">
        <div className="max-w-xl text-center">
          <Reveal>
            <h1 className="font-serif text-5xl md:text-6xl font-normal text-ink leading-tight mb-6">
              Ananya Kedlaya
            </h1>

            <p className="font-sans text-base text-stone-warm leading-relaxed mb-8">
              Artist and creative technologist based in London. I make creative
              works that explore people and their relationship to space, presence,
              and the physical world around them. My practice is focused on
              sensor-driven installations that use technology to make artistic and
              immersive experiences.
            </p>

            <div className="flex flex-col items-center gap-2">
              <a
                href="mailto:kedlayaananya@gmail.com"
                className="label border-b border-ink text-ink pb-0.5 hover:opacity-60 transition-opacity w-fit"
              >
                kedlayaananya@gmail.com →
              </a>

              <a
                href="/Resume_Ananya.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="label border-b border-ink text-ink pb-0.5 hover:opacity-60 transition-opacity w-fit"
              >
                <CgFileDocument className="inline mr-1" />
                Resume →
              </a>
            </div>
          </Reveal>
        </div>
      </div>
      {/* Bio */}
      {/* <div className="px-10 md:px-16 lg:px-20 py-20 border-b border-cream-400/60 max-w-3xl">
        <Reveal>
          <p className="label mb-8">Statement</p>
          <div className="space-y-5 font-sans text-base text-stone-warm leading-relaxed">
            <p>
              My practice is about exploring how technology can be used to create meaningful interactions between people and their environment. A way to create moments of connection and reflection in the spaces we inhabit.
            </p>
            <p>
              I combine software developmennt with hardware programming to enhance user experince of product usage and develop artistic works that merge the physical and digital.

              I'm passionate about art and creativity to innovate products that merge technical boundries
            </p>
            <p>
              I came from software engineering, which shapes how I think about systems.
              I still write code, but the software is in service of the work, not the point of it.
            </p>
          </div>
        </Reveal>
      </div> */}

      <div className="relative border-b border-cream-400/60 overflow-hidden bg-gradient-to-b from-[#FFFDF5] via-[#FCFAF2] to-[#F7F4EF]">
        <Reveal>


          {/* Thread */}
          {/* <svg
      className="absolute inset-0 w-full h-full pointer-events-none  -z-10"
      viewBox="0 0 1000 900"
      preserveAspectRatio="none"
    >
      <path
        d="
          M120 -80
          C420 70 580 180 840 120
          C900 250 700 290 500 280
        "
        fill="none"
        stroke="#c40922"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="10 5"
        stroke-dashoffset = "50"
      />

       <path
        d="
         
          M80 280
          C650 520 840 560 760 700
          C650 820 360 760 180 820
        "
        fill="none"
        stroke="#c40922"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="10 5"
        stroke-dashoffset = "50"
      />
       {/* <path
        d="
          M120 -80
          C420 70 580 180 840 120
          C900 250 700 290 500 280
          C250 270 180 420 420 470
          C650 520 840 560 760 700
          C650 820 360 760 180 820
        "
        fill="none"
        stroke="#c40922"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="10 5"
        stroke-dashoffset = "50"
      /> */}
          {/* <path
        d="
          M120 -80
          C420 70 580 180 840 120
          C900 250 700 290 500 280
          C250 270 180 420 420 470
          C650 520 840 560 760 700
          C650 820 360 760 180 820
        "
        fill="none"
        stroke="#c40922"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="10 5"
        stroke-dashoffset = "50"
      /> 
    </svg> */}


          {/* Paragraphs */}
          <div className="relative max-w-6xl mx-auto h-[760px]">

            <div className="absolute left-[16%] top-[80px] bg-cream px-8 py-6 max-w-sm z-10">
              <p className="font-sans text-center text-stone-warm leading-relaxed bg-cream">
                My practice is about exploring how technology can be used to create
                meaningful interactions between people and their environment. A way
                to create moments of connection and reflection in the spaces we
                inhabit.
              </p>
            </div>

            <div className="absolute right-[10%] top-[320px] bg-cream px-8 py-6 max-w-sm">
              <p className="font-sans text-center text-stone-warm leading-relaxed">
                I combine software development with hardware programming to enhance
                user experience and develop artistic works that merge the physical
                and digital. I'm passionate about using art and creativity to push
                technical boundaries.
              </p>
            </div>

            <div className="absolute left-1/2 -translate-x-1/2 bottom-16 bg-cream px-8 py-6 max-w-sm">
              <p className="font-sans text-center text-stone-warm leading-relaxed">
                I come from software engineering, which shapes how I think about
                systems. I still write code, but the software is in service of the
                work, not the point of it.
              </p>
            </div>

          </div>
        </Reveal>
      </div>

      {/* Skills — minimal, contextual */}
      {/* <div className="grid grid-cols-1 md:grid-cols-4 border-b border-cream-400/60 divide-y md:divide-y-0 md:divide-x divide-cream-400/60">
        {[
          { label: 'What I see', items: ['Data', 'Patterns', 'Interactions'] },
          { label: 'Materials', items: ['Sensors', 'Actuators', 'Displays', 'Paper', 'Paint', 'Microcontroller'] },
          { label: 'Making', items: ['Code', 'Design', 'Sketch', 'Solder', 'Circuit Design', '3D Printing'] },
          { label: 'What it becomes', items: ['Interactive installations', 'Physical computing', 'Prototypes', 'Physical Products', 'Physicalization of Data'] },
        ].map((group, i) => (
          <Reveal key={group.label} delay={i * 80}>
            <div className="px-10 md:px-12 py-12">
              <p className="label mb-6">{group.label}</p>
              <ul className="space-y-2">
                {group.items.map(item => (
                  <li key={item} className="font-sans text-sm text-stone-warm flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-cream-400 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div> */}

      <div className="border-b border-cream-400/60 py-32 overflow-hidden">
        <Reveal>
          <div className="relative max-w-7xl mx-auto h-[850px] px-8">

            {/* Title */}
            <div className="absolute left-1/2 -translate-x-1/2 top-0 text-center">
            
              <h2 className="font-serif text-5xl text-ink bg-[#F8F3D6] px-10 py-2 inline-block">
                Anatomy of my Practice
              </h2>
            </div>

            {/* Connecting lines */}
            <svg
              className="absolute inset-0 w-full h-full pointer-events-none"
              viewBox="0 0 1200 850"
            >
              <g stroke="#927926" strokeWidth="1.5"
                strokeLinecap="round"
                strokeDasharray="10 5" fill="none">

                {/* main stem */}
                <path d="M600 100 C600 280 600 350 600 350" />
                <path d="M600 400 C600 440 600 500 600 840" />

                {/* branches */}
                <path d="M600 220 C700 20 400 200 220 180" />
                <path d="M600 320 C900 30 70 260 900 250" />
                <path d="
                      M600 430
                      C500 900 900 300 500 500
                      C510 500 180 620 100 500
                      " />


                      <path d="
                      M600 520
                      C700 760 1020 550 1000 690
                      C1000 720 800 800 1050 840
                
                      " />
                {/* tiny circles */}
                <circle cx="600" cy="220" r="4" fill="#bd3416" />
                <circle cx="600" cy="320" r="4" fill="#bd3416" />
                <circle cx="600" cy="430" r="4" fill="#bd3416" />
                <circle cx="600" cy="520" r="4" fill="#bd3416" />

              </g>
            </svg>

            {/* Observe */}
            <div className="absolute left-12 top-36 max-w-xs">
              <p className="label mb-2">01 / OBSERVE</p>

              <h3 className="font-serif text-4xl mb-5">
               Things I see
              </h3>

              <div className="space-y-2 font-sans text-stone-warm">
                <p>• Data</p>
                <p>• Patterns</p>
                <p>• Interactions</p>
          
              </div>
            </div>

            {/* Materials */}
            <div className="absolute right-10 top-52 max-w-xs text-right">
              <p className="label mb-2">02 / MATERIALS</p>

              <h3 className="font-serif text-4xl mb-5">
                And get my hands dirty with
              </h3>

              <div className="space-y-2 font-sans text-stone-warm">
                <p>Sensors</p>
                <p>Actuators</p>
                <p>Paper</p>
                <p>Paint</p>
                <p>Microcontrollers</p>
              </div>
            </div>

            {/* Making */}
            <div className="absolute left-24 top-[470px] max-w-xs">
              <p className="label mb-2">03 / MAKING</p>

              <h3 className="font-serif text-4xl mb-5">
                And add a little bit of spice
              </h3>

              <div className="space-y-2 font-sans text-stone-warm">
                <p>Sketching</p>
                <p>Programming</p>
                <p>Circuit Design</p>
                <p>Soldering</p>
                <p>Prototyping</p>
              </div>
            </div>

            {/* Outcome */}
            <div className="absolute right-12 top-[620px] max-w-sm text-right">
              <p className="label mb-2">04 / OUTCOME</p>

              <h3 className="font-serif text-4xl mb-5">
                To make
              </h3>

              <div className="space-y-2 font-sans text-stone-warm">
                <p>Interactive Installations</p>
                <p>Physical Computing</p>
                <p>Products</p>
                <p>Physicalised Data</p>
              </div>
            </div>

            {/* Centre annotation */}
            <div className="absolute left-1/2 top-[360px] -translate-x-1/2 w-56 text-center">

              {/* <div className="w-3 h-3 rounded-full bg-ink mx-auto mb-4"/> */}

              <p className="font-serif italic text-2xl text-[#bd3416]">
                Curiosity
              </p>


            </div>

          </div>
        </Reveal>
      </div>




      {/* Timeline */}
      <div className="border-b border-cream-400/60">
        <div className="px-10 md:px-16 lg:px-20 py-5 border-b border-cream-400/60">
          <span className="label">Timeline</span>
        </div>
        <div className="divide-y divide-cream-400/60">
          {timeline.map((item, i) => (
            <Reveal key={item.year} delay={i * 60}>
              <div className="px-10 md:px-16 lg:px-20 py-8 grid grid-cols-1 md:grid-cols-[100px_1fr] gap-4 hover:bg-cream-200/40 transition-colors duration-200">
                <span className="font-mono text-sm text-stone-muted">{item.year}</span>
                <div>
                  <h3 className="font-serif text-lg text-ink font-normal mb-2">{item.title}</h3>
                  <p className="font-sans text-sm text-stone-warm leading-relaxed">{item.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>



      {/* Contact */}
      {/* <div className="px-10 md:px-16 lg:px-20 py-20 bg-[#f5f3eb]">
        <Reveal className="max-w-xl">
          <p className="label mb-6">Get in touch</p>
          <p className="font-serif text-2xl text-[#ebc113] font-normal mb-8 leading-relaxed">
            Open to commissions, exhibitions, residencies, and collaboration.
          </p>
          <div className="flex flex-col gap-3">
            <a href="mailto:kedlayaananya@gmail.com" className="label border-b border-ink text-ink pb-0.5 hover:opacity-60 transition-opacity w-fit">
              kedlayaananya@gmail.com →
            </a>
            <a href="https://ananyakedlaya.com" className="label text-stone-muted hover:text-ink transition-colors w-fit">
              ananyakedlaya.com
            </a>
          </div>
        </Reveal>
      </div> */}

      <div className="relative overflow-hidden px-10 md:px-16 lg:px-20 py-20 bg-[#F8F5EE]">
  {/* Subtle warm glow */}
  <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(201,162,39,0.08),transparent_55%)] pointer-events-none" />

  <Reveal className="relative max-w-xl">
    <p className="label mb-6 text-stone-500">Get in touch</p>

    <p className="font-serif text-2xl md:text-3xl text-[#C9A227] font-normal mb-8 leading-relaxed">
      Open to commissions, exhibitions, residencies, and collaboration.
    </p>

    <div className="flex flex-col gap-3">
      <a
        href="mailto:kedlayaananya@gmail.com"
        className="label border-b border-[#1E1E1E] text-[#1E1E1E] pb-0.5 hover:text-[#C9A227] hover:border-[#C9A227] transition-all duration-300 w-fit"
      >
        kedlayaananya@gmail.com →
      </a>

      <a
        href="https://ananyakedlaya.com"
        className="label text-stone-500 hover:text-[#C9A227] transition-colors duration-300 w-fit"
      >
        ananyakedlaya.com
      </a>
    </div>
  </Reveal>
</div>

    </div>
  );
}


